import { Modal } from "antd"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { SystemDescriptions } from "src/common/descriptions"
import { RootState } from "src/state/reducer"
import { ServiceCategoryForm } from "./ServiceCategoryForm"
import { ServiceCategory } from "src/common/models/serviceCategory"
import { upsertServiceCategoryApi } from "../../state/action"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { UPSERT_SERVICE_CATEGORY_API } from "../../state/actionTypes"

interface ReduxProps {
    upsertServiceCategorySuccess?: boolean
    isUpsertingServiceCategory: boolean
}

interface Props {
    open: boolean
    initialValues?: ServiceCategory
    onFinish: () => void
    onCancel: () => void
}

export const CreateServiceCategory = (props: Props) => {
    const dispatch = useDispatch()

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        upsertServiceCategorySuccess: state.service.upsertServiceCategorySuccess,
        isUpsertingServiceCategory: serviceLoading(state, [UPSERT_SERVICE_CATEGORY_API]),
    }))

    const descriptions = SystemDescriptions.PAGES.SERVICE.CREATE_SERVICE_CATEGORY

    useEffect(() => {
        if (reduxProps.upsertServiceCategorySuccess) {
            props.onFinish()
        }
    }, [reduxProps.upsertServiceCategorySuccess])

    const onFinish = (serviceCategory: Partial<ServiceCategory>) => {
        dispatch(upsertServiceCategoryApi(serviceCategory as ServiceCategory))
    }

    const onCancel = () => {
        props.onCancel()
    }

    return (
        <Modal
            title={descriptions.TITLE}
            centered
            open={props.open}
            onOk={() => { }}
            onCancel={props.onCancel}
            footer={null}
            closable
            width={1040}
        >
            <ServiceCategoryForm
                initialValues={props.initialValues}
                onFinish={onFinish}
                onCancel={onCancel}
            />
        </Modal>
    )
}
